var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`SkeletonSreen ${_vm.shade}`,style:({ height: _vm.height, width: _vm.computedWidth })})
}
var staticRenderFns = []

export { render, staticRenderFns }